export default __webpack_public_path__ + "static/media/junaid.fa672c2b.png";